export default "__VITE_ASSET__C991XV31__"